import {Box, Divider, Drawer, Stack, useTheme} from "@mui/material";
import {FiHome, FiLock, FiLogOut, FiUsers, FiMonitor, FiSettings, FiKey, FiShield} from "react-icons/fi";
import logo from "../../assets/logo.png";
import logoCollapsed from "../../assets/ts.png";
import useLogout from "../../hooks/useLogout";
import styles from "./Sidebar.module.css";
import MenuItem from "../MenuItem/MenuItem";

const Sidebar = ({isOpen, setIsOpen}) => {
  const {logout} = useLogout();

  const handleLogout = () => {
    logout();
  };

  const menuItems = [
    {text: "Dashboard", icon: <FiHome />, path: "/dashboard"},
    {text: "Usuarios", icon: <FiUsers />, path: "/users"},
    {text: "Roles", icon: <FiLock />, path: "/roles"},
    {text: "Clientes", icon: <FiMonitor />, path: "/clients"},
    {text: "Scopes", icon: <FiSettings />, path: "/scopes"},
    {text: "Tokens", icon: <FiKey />, path: "/tokens"},
    {text: "M2M Tokens", icon: <FiShield />, path: "/m2m-tokens"}
  ];

  const theme = useTheme();
  return (
    <Drawer
      variant="permanent"
      open={isOpen}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      className={styles.container}
      sx={{
        width: isOpen ? 180 : 80,
        "& .MuiDrawer-paper": {
          width: isOpen ? 180 : 80,
          transition: "width 0.3s ease",
          backgroundColor: theme.palette.background.paper,
          boxShadow: "6px 6px 10px rgba(0, 0, 0, 0.2)",
          borderRadius: "10px",
          height: "calc(100vh - 40px)",
          margin: "20px",
          position: "relative",
          overflow: "visible"
        }
      }}
    >
      <Box className={styles.header}>
        <img
          src={isOpen ? logo : logoCollapsed}
          alt="Logo"
          className={styles.logo}
          style={{
            width: isOpen ? "150px" : "40px"
          }}
        />
      </Box>
      <Stack direction="column" spacing={1} className={styles.menu}>
        {menuItems.map(({text, icon, path, onClick}) => (
          <MenuItem key={text} text={text} icon={icon} isOpen={isOpen} onClick={onClick} path={path} />
        ))}
      </Stack>
      <Box className={styles.footer}>
        <Divider className={styles.divider} />
        <MenuItem
          key={"Salir"}
          text={"Salir"}
          icon={<FiLogOut color="#d53c65" />}
          isOpen={isOpen}
          onClick={handleLogout}
        ></MenuItem>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
